import { FC, useState } from 'react';
import { CheckboxChangeEvent } from 'antd/es/checkbox';

import { CenterModal, ModalFooter } from 'shared/components';
import { Button, Checkbox, Icon, openNotification, Text } from 'shared/components/ui';
import { useGetCurrentUserQuery } from 'services';
import { CandidatesWithCount } from 'features/csv-export';

import styles from './index.module.scss';

interface Props {
	onClose: () => void;
	candidates: CandidatesWithCount;
	handleExport: (isFull: boolean) => void;
	type: 'profiles' | 'companies';
}

export const TechnographicsExportCsvModal: FC<Props> = ({ onClose, candidates, handleExport, type }: Props) => {
	const [isFull, setIsFull] = useState(false);

	const handleCheckbox = (e: CheckboxChangeEvent) => {
		setIsFull(e.target.checked);
	};

	const { data } = useGetCurrentUserQuery();

	const handleSubmit = async () => {
		try {
			await handleExport(isFull);

			openNotification({
				key: 'export-notification',
				text: 'We’re preparing your CSV file and sending it to your email. Please check your inbox in a few minutes.',
				closable: true
			});

			onClose();
		} catch (e) {
			console.error(e);
		}
	};

	return (
		<CenterModal onClose={onClose} icon="export" iconColor="green" title={`Export ${type} into CSV file`}>
			<div className={styles.body}>
				<div className={styles.info}>
					<Text variant="inter/14/regular">{type.toString()}</Text>
					<div className={styles.infoCount}>
						<Icon icon="person" />
						<Text variant="inter/14/medium" color="dark_blue">
							{candidates.count}
						</Text>
					</div>
				</div>
				{type === 'profiles' && (
					<Checkbox className={styles.checkbox} checked={isFull} onChange={handleCheckbox}>
						<Text variant="inter/14/medium">Add companies</Text>
					</Checkbox>
				)}
			</div>
			<ModalFooter>
				<div className={styles.footer}>
					<Button type="ghost" onClick={onClose}>
						<Text variant="inter/15/semi" color="light_blue">
							Cancel
						</Text>
					</Button>
					{data && (
						<div className={styles.footerButton} onClick={handleSubmit}>
							<Text variant="inter/15/semi" color="white">
								Email CSV
							</Text>
						</div>
					)}
				</div>
			</ModalFooter>
		</CenterModal>
	);
};
